import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=18dea15c&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=ts&"
export * from "./Service.vue?vue&type=script&lang=ts&"
import style0 from "./Service.vue?vue&type=style&index=0&id=18dea15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dea15c",
  null
  
)

export default component.exports